import { render, staticRenderFns } from "./QuestionTimer.vue?vue&type=template&id=76ac2b9c&"
import script from "./QuestionTimer.vue?vue&type=script&lang=ts&"
export * from "./QuestionTimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports